import styled from 'styled-components'

const H5 = styled.h5`
  color: ${props => props.theme.colors.darkGray};
  font-weight: 600;
`

export default H5
